import React, { useEffect, useState } from "react";
import useLocation from "./useLocation";

export function useMAPriceUp() {
  const [isMAPriceUp, setMAPriceUp] = useState(false);
  const { search } = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    if (searchParams.has("isMAPriceUp", "Y")) {
      if (!isMAPriceUp) {
        setMAPriceUp(true);
      }
    } else {
      if (isMAPriceUp) {
        setMAPriceUp(false);
      }
    }
  }, [search]);

  return isMAPriceUp;
}

export function withMAPriceUp(Component) {
  return function WrappedComponent(props) {
    const isMAPriceUp = useMAPriceUp();
    return (
      <Component {...props} isMAPriceUp={isMAPriceUp} />
    );
  }
}
